import React, { useEffect, useRef, useState } from 'react';
import {
  useStyles,
  SearchContainer,
  InputContainer,
  TableControl,
  InputSelectHospital,
} from './styles';
import Layout from 'shared/component/Layout';
import {
  Button,
  Typography,
  Divider,
  Tooltip,
  TableCell,
} from '@material-ui/core';
import { useAdministrators } from 'hook/administrators';
import DefaultTable from 'shared/component/DefaultTable';
import CustomSelect from 'shared/component/forms/CustomSelect';
import SearchInputDebounce from 'shared/component/forms/SearchInputDebounce';
import { AvatarNameComponent } from 'shared/component/AvatarNameComponent';
import { useHistory } from 'react-router-dom';
import HasPermission from 'utils/checkPermission';
import useUnit from 'hook/unit';
import { useGroups } from 'hook/groups';
import moment from 'moment';
import '../../../shared/fixedtab.css';

export default function AdminPageList() {
  const classes = useStyles();
  const { push } = useHistory();
  const pageRef = useRef(1);

  const { units, getUnits } = useUnit();
  const { data: groupsList, getList: getGroups } = useGroups();
  const {
    data: dataList,
    loading: loadingAdm,
    total: totalAdm,
    deleteLoading,
    getList,
    getDelete,
  } = useAdministrators();

  const [filter, setFilter] = useState({
    per_page: 10,
    search: '',
    status: 1,
    group_id: '',
    unit_id: '',
  });

  const [unitFilter, setUnitFilter] = useState({
    unitPage: 1,
    unitPerPage: 30,
    unitSearch: '',
  });

  const [unitSelected, setUnitSelected] = useState({
    label: 'Todos',
    value: 'all',
  });
  const [selectedGroup, setSelectedGroup] = useState({
    label: 'Todos',
    value: 'all',
  });

  useEffect(() => {
    const page = Number(localStorage.getItem('administratorPage')) || 1;
    getList({ ...filter, page });
  }, [filter]);

  useEffect(() => {
    getUnits(
      unitFilter.unitPage,
      unitFilter.unitPerPage,
      unitFilter.unitSearch
    );
  }, [unitFilter.unitPage, unitFilter.unitSearch]);

  useEffect(() => {
    getGroups();
  }, []);

  // Options
  const unitOptions = units.dataUnits.map((unit) => ({
    label: unit.name,
    value: unit.id,
  }));
  const groupOptions = groupsList.map((group) => ({
    label: group.name,
    value: group.id,
  }));

  // Handlers
  const handleSearch = (search) =>
    setFilter((prev) => ({ ...prev, page: 1, search }));

  const handleChangeUnit = (val) => {
    setUnitSelected(val);
    setFilter((prev) => ({
      ...prev,
      unit_id: val?.value === 'all' ? '' : val?.value,
      page: 1,
    }));
  };

  const handleChangeGroup = (val) => {
    setSelectedGroup(val);
    setFilter((prev) => ({
      ...prev,
      group_id: val?.value === 'all' ? '' : val?.value,
      page: 1,
    }));
  };

  const handleDeleteProfessional = (id) => {
    getDelete({
      id,
      params: { ...filter, page: dataList.length > 1 ? filter.page : 1 },
    });
  };

  const handleChangePage = (page) => {
    getList({ ...filter, page });
  };
  const searchUnit = (val) =>
    setUnitFilter((prev) => ({ ...prev, unitSearch: val }));

  const searchGroup = (val) => {
    getGroups({ search: val });
  };

  // Pagination handlers for units
  const handleUnitPagination = (direction) => {
    const totalPage = Math.ceil(units.totalUnits / unitFilter.unitPerPage);
    const nextPage = pageRef.current + (direction === 'next' ? 1 : -1);

    if (nextPage >= 1 && nextPage <= totalPage) {
      setUnitFilter((prev) => ({ ...prev, unitPage: nextPage }));
      pageRef.current = nextPage;
    }
  };

  const columns = [
    { id: 'id', label: '#', minWidth: 10 },
    {
      id: 'name',
      label: 'Nome',
      minWidth: 100,
      render: (rowData) => <AvatarNameComponent rowData={rowData} />,
    },
    { id: 'cpf', label: 'CPF', minWidth: 100 },
    {
      id: 'unit',
      label: 'Hospital',
      minWidth: 100,
      render: ({ units }) => (
        <TableCell>{units?.map((u) => u?.name).join(', ') || '...'}</TableCell>
      ),
    },
    { id: 'group.name', label: 'Grupo', minWidth: 100 },
    {
      id: 'created_at',
      label: 'Data de criação',
      minWidth: 10,
      render: (rowData) => (
        <TableCell>{moment(rowData.created_at).format('DD/MM/yyyy')}</TableCell>
      ),
    },
  ];

  return (
    <Layout title="Administradores" showToday backArrow>
      <div id="fixed-tab">
        <Divider style={{ paddingTop: 2, marginRight: 20 }} />
      </div>
      <SearchContainer>
        <InputContainer>
          <SearchInputDebounce
            value={filter.search}
            className={classes.inputWidth}
            onChange={handleSearch}
            placeholder="Busque por nome ou CPF"
            style={{ alignItems: 'center', height: 48, width: '90%' }}
          />
        </InputContainer>

        <InputSelectHospital data-cy="inputSelectHospital">
          <CustomSelect
            isProf={false}
            name="unit"
            loading={units.loadingUnits}
            placeholder="Selecione o hospital"
            handleChange={handleChangeUnit}
            value={unitSelected}
            searchItem={searchUnit}
            pagination={() => handleUnitPagination('next')}
            toTopPagination={() => handleUnitPagination('prev')}
            options={[{ label: 'Todos', value: 'all' }, ...unitOptions]}
            isClearable
          />
        </InputSelectHospital>

        <InputSelectHospital>
          <CustomSelect
            isProf={false}
            name="group"
            loading={false}
            placeholder="Selecione o grupo"
            handleChange={handleChangeGroup}
            value={selectedGroup}
            searchItem={searchGroup}
            options={[{ label: 'Todos', value: 'all' }, ...groupOptions]}
            isClearable
          />
        </InputSelectHospital>

        <div className={classes.rowContainer}>
          <Tooltip
            title={HasPermission('user/c') ? '' : 'Você não tem permissão'}
            placement="bottom"
            arrow
          >
            <Button
              onClick={
                HasPermission('user/c')
                  ? () => push('/cadastros/administradores/cadastrar')
                  : undefined
              }
              className={classes.registerButton}
            >
              <Typography className={classes.registerText}>
                Cadastrar administrador
              </Typography>
            </Button>
          </Tooltip>
        </div>
      </SearchContainer>

      <TableControl>
        <DefaultTable
          dataList={dataList}
          permissions={{
            read: 'user/r',
            create: 'user/c',
            delete: 'user/d',
            update: 'user/u',
          }}
          columns={columns}
          loading={loadingAdm}
          totalList={totalAdm}
          redirectTo="/cadastros/administradores/editar"
          perPage={filter.per_page}
          handleChangePage={handleChangePage}
          deleteLoading={deleteLoading}
          onDeleteRequest={handleDeleteProfessional}
          showExportButton={false}
          pageStorageKey={'administratorPage'}
        />
      </TableControl>
    </Layout>
  );
}
